import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { TramiteSuperfinancieraService } from '../../../../services/tramite-superfinanciera.service';
import { Constants } from '../../../../constants/constants';
import { TramiteSuperfinancieraDto } from '../../../../dto/tramites/tramite-superfinanciera.dto';
import { AlertaModalService } from '../../../../services/util/alerta-modal.service';
import { UtilService } from '../../../../services/util.service';
import { InfoPantallaDTO } from '../../../../dto/util/infoPantallaDTO';
import { PersonaDto } from '../../../../dto/tramites/persona.dto';
import { TramiteService } from '../../../../services/tramite.service';
import { TramiteDTO } from '../../models/tramiteDTO';
import { AnexoPrecargaResponseDto } from '../../../../dto/anexo/anexo-tramite.dto';
import { MunicipioDto } from '../../../../dto/expediente/municipio.dto';
import { firstValueFrom } from 'rxjs';
import { Location } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { ArchivosFormDTO } from '../../../../dto/expediente/archivos-form.dto';
import { Router } from '@angular/router';
import { ListaValorService } from '../../sic/proteccion-al-consumidor/services/lista-valor.service';
import { LanguageService } from '../../../../services/util/language.service';
import { SfcDemandanteComponent } from '../sfc-demandante/sfc-demandante.component';
import { SfcApoderadoComponent } from '../sfc-apoderado/sfc-apoderado.component';

interface EstadoPasos {
  paso: string;
  valor?: boolean;
}

@Component({
  selector: 'app-superfinanciera-proteccion-consumidor',
  templateUrl: './sfc-procon.component.html',
  styleUrl: './sfc-procon.component.scss',
})
export class SfcProConComponent implements OnInit {
  idiomaActual: string = 'es';
  tipoPersona?: number;
  idTramite = 0;
  tramiteSfc?: TramiteSuperfinancieraDto;
  ultimoPaso = false;
  paso = 0;
  estadoPasos: EstadoPasos[] = [];

  //Componente carga archivos
  archivosPreCargados?: AnexoPrecargaResponseDto[];
  mostrarComponenteCarga: boolean = true;

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Multilenguaje
  sfcText: any = {};
  comunText: any = {};
  alertaText: any = {};

  isVolver: boolean = false;
  formTipoDemandante!: FormGroup;
  formDemandante!: FormGroup;
  formApoderado!: FormGroup;
  formDemandado!: FormGroup;
  formDetalleRequest!: FormGroup;
  formDetalleRequestTramite!: FormGroup;
  formReclamo!: FormGroup;
  formNotificacionesDemandantes!: FormArray;
  formNotificacionesDemandados!: FormArray;
  nombreCortoLimpio = '';

  idDemandante: number | null = null;


  apoderado: PersonaDto = {};
  listaMunicipios: MunicipioDto[] = [];
  proceso: string = '';
  entidad: string = '';

  festivos: string[] = [];

  @ViewChild(SfcDemandanteComponent) demandanteComponent!: SfcDemandanteComponent;
  @ViewChild(SfcApoderadoComponent) apoderadoComponent!: SfcApoderadoComponent;

  constructor(
    private readonly service: TramiteSuperfinancieraService,
    private readonly alertaModalService: AlertaModalService,
    private readonly utilService: UtilService,
    private readonly router: Router,
    private readonly tramiteService: TramiteService,
    private readonly languageService: LanguageService,
    private readonly location: Location,
    private readonly translate: TranslateService,
    private readonly fb: FormBuilder,
    private readonly listaValorService: ListaValorService
  ) {
    this.getDiasFestivos();
  }

  ngOnInit(): void {
    this.idiomaActual = this.languageService.getCurrentLanguage();

    this.languageService.currentLanguage$.subscribe(lang => {
      this.idiomaActual = lang;
    });
    this.tramiteService.obtenerNombreEntidadPorId(4).subscribe({
      next: (data) => {
        this.entidad = data.entidad;
        this.proceso = data.nombreCompletoTramite || '';
      },
      error: (err) => console.error('Error al obtener entidad y proceso:', err),
    });
    const nombreCorto = sessionStorage.getItem('tramiteSeleccionado');
    if (nombreCorto) {
      this.nombreCortoLimpio = nombreCorto.trim().replace(/^"|"$/g, '').toUpperCase();
    }
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla:
        'Inicio de Proceso de protección al consumidor en la entidad Superintendencia ' +
        'financiera',
      descripcionPantalla:
        'En esta pantalla usted podrá iniciar un Proceso de protección al consumidor en la ' +
        'Superintendencia financiera',
      pasos: [],
      change: async op =>
        await this.guardarAntesDeSalir(this.alertaModalService, this.location, op),
    };

    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.tramiteService
      .consultarTramitePendiente(
        infoInicioSesion.idUsuario,
        Constants.SFC_PROCON
      )
      .subscribe(resp => {
        if ((resp as { Id: number }).Id !== null) {
          // Se consume el servicio que obtiene el detalle del trámite
          this.alertaModalService.confirmacion(
            this.alertaText['continuar-solicitud-almacenada'],
            '',
            () => {
              this.consultarTramitePorID(resp.Id);
              this.mostrarComponenteCarga = false;
            },
            () => {
              this.tramiteSfc = undefined;
            },
            true
          );
        } else {
          this.tramiteSfc = undefined;
        }
      });

    this.utilService.changeInfoPantalla(this.infoPantalla);
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.sfcText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
    sessionStorage.removeItem('tramiteSfc');
    sessionStorage.removeItem('demandantes');
    sessionStorage.removeItem('demandandos');
    sessionStorage.removeItem('apoderados');
    sessionStorage.removeItem('anexos');


  }

  // lista
  getDiasFestivos() {
    this.listaValorService.getFestivos().subscribe((response: { Id: number; Fecha: string }[]) => {
      this.festivos = response.map(f => new Date(f.Fecha).toISOString().split('T')[0]);
      sessionStorage.setItem(
        Constants.LISTA_FESTIVOS,
        JSON.stringify(this.festivos)
      );

    });
  }

  consultarTramitePorID(id: number) {
    this.idTramite = id;
    this.tramiteService
      .cargarTramitePendiente(id)
      .subscribe((resp: TramiteDTO) => {
        if (resp) {
          this.tramiteSfc = resp as unknown as TramiteSuperfinancieraDto;
          sessionStorage.setItem(
            'tramiteSfc',
            JSON.stringify(resp)
          );
          if (resp.anexos) {
            this.archivosPreCargados = resp.anexos;
            this.mostrarComponenteCarga = true;
            sessionStorage.setItem(
              'anexos',
              JSON.stringify(this.archivosPreCargados)
            );
          }
          // this.idDemandante = resp.demandante[0].id;
        }
      });
  }

  getPaso(atras: { paso: number }) {
    if (atras.paso) {
      this.paso = atras.paso;
    }
  }

  async guardarAntesDeSalir(alertas: AlertaModalService, loc: Location, op?: () => void) {
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    const rawTramite = sessionStorage.getItem('tramiteSfc');
    this.tramiteSfc = rawTramite ? JSON.parse(rawTramite) : undefined;
    if (this.tramiteSfc == undefined) {
      this.tramiteSfc = {
        id: null,
        idTipoTramite: Constants.TRAMITES.SUPER_FINANCIERA,
        anexos: [],
        demandado: [],
        demandante: [],
        notificacionesDemandado: null,
        notificacionesDemandante: null,
        usuario: {
          id: infoInicioSesion.idUsuario,
        },
        enviar: false,
      };
    }
    if (this.formDemandante) {
      if (this.formTipoDemandante) {
        this.demandanteComponent.agregarDemandante(false, true);
      }
      let demandantes: PersonaDto[] = JSON.parse(sessionStorage.getItem('demandantes')!);
      if (!this.tramiteSfc?.demandante || this.tramiteSfc.demandante.length === 0) {
        // Caso 1: No hay demandantes aún → copiar todo
        this.tramiteSfc!.demandante = demandantes ? [...demandantes] : [];
      } else if (demandantes) {

        // Caso 2: Ya existen demandantes → mezclar

        // A) los que vienen SIN id → agregarlos
        const sinId = demandantes.filter(d => d.id == undefined);

        // B) los que vienen CON id → reemplazar completando la lista
        const conId = demandantes.filter(d => d.id != undefined);

        // C) Construir la nueva lista final
        this.tramiteSfc!.demandante = [
          ...conId,
          ...sinId,
        ];
      }
    }

    if (this.formApoderado) {
      this.apoderadoComponent.agregarApoderado(true);
    }

    // Leer los apoderados existentes en sessionStorage
    let apoderadosSession: PersonaDto[] =
      JSON.parse(sessionStorage.getItem('apoderados') ?? '[]');

    // Si no existe arreglo en el tramite → inicializar
    if (!this.tramiteSfc.apoderados) {
      this.tramiteSfc.apoderados = [];
    }

    // Convertir valores nulos a arreglo vacío
    const apoderadosTramite = this.tramiteSfc.apoderados ?? [];


    const nuevos = apoderadosSession.filter(a => a.id == undefined);
    const existentes = apoderadosSession.filter(a => a.id != undefined);

    this.tramiteSfc.apoderados = [
      ...existentes,
      ...nuevos
    ];
    if (this.tramiteSfc.apoderados && this.tramiteSfc.apoderados.length > 0) {
      this.tramiteSfc.tieneApoderado = true;
    }

    if (this.formDemandado != undefined) {
      let demandados: PersonaDto[] = JSON.parse(
        sessionStorage.getItem('demandados')!
      );
      if (this.formDemandado.valid) {
        this.agregarDemandado();
      } else {
        if (
          this.tramiteSfc?.demandado == undefined ||
          this.tramiteSfc?.demandado.length == 0
        ) {
          if (demandados) {
            demandados.forEach(elemento => {
              this.tramiteSfc?.demandado?.push(elemento);
            });
          }
        }
      }
    } else {
      let demandados: PersonaDto[] = JSON.parse(
        sessionStorage.getItem('demandados')!
      );
      if (
        this.tramiteSfc?.demandado == undefined ||
        this.tramiteSfc.demandado.length == 0
      ) {
        if (demandados) {
          demandados.forEach(elemento => {
            this.tramiteSfc?.demandado?.push(elemento);
          });
        }
      } else {
        if (demandados) {
          demandados.forEach(elemento => {
            if (elemento.id == undefined) {
              this.tramiteSfc?.demandado?.push(elemento);
            }
          });
        }
      }
    }
    if (this.formDetalleRequest != undefined && this.formDetalleRequestTramite != undefined) {
      if (this.formDetalleRequest.valid && this.formDetalleRequestTramite.valid) {

        this.tramiteSfc = {
          ...this.tramiteSfc,
          ocurrioExtranjero: this.formDetalleRequest.value['inconformidadExterior'] === 1,
          producto: {
            id: this.formDetalleRequest.get('producto')?.value,
          },
          motivoInconformidad: {
            id: this.formDetalleRequest.get('motivo')?.value,
          },
          detalleInconformidad: this.formDetalleRequest.get('detalleInconformidad')?.value,
          canal: {
            id: this.formDetalleRequest.get('canal')?.value,
          },
          descripcionHechos: this.formDetalleRequest.get('detalleHechos')?.value,
          descripcionPretenciones: this.formDetalleRequest.get('pretenciones')?.value,
          conCuantia: this.formDetalleRequestTramite.get('ingresaCuantia')?.value === 1,
          cuantia: this.formDetalleRequestTramite.get('cuantia')?.value,
          conIndemnizacion: this.formDetalleRequestTramite.get('indemnizacion')?.value === 1,
          juramentoEstimatorio: this.formDetalleRequestTramite.get('juramento')?.value,
        };
      }
    }

    if (this.formReclamo != undefined) {
      if (this.formReclamo.valid) {
        this.tramiteSfc = {
          ...this.tramiteSfc,
          tipoReclamacion: this.formReclamo.get('tipoReclamacion')?.value,
          fechaReclamo: this.formReclamo.get('fechaReclamo')?.value,
          recibioRespuesta:
            this.formReclamo.get('recibioRespuesta')?.value === 'S',
          canalRespuesta: this.formReclamo.get('canalReclamo')?.value,
          fechaRespuesta: this.formReclamo.get('fechaRespuesta')?.value,
        };
      }
    }


    if (this.formNotificacionesDemandantes != undefined && this.formNotificacionesDemandados != undefined) {
      const demandantes: string[] = [];
      const demandados: string[] = [];
      const valoresDemandantes = this.cargarDemandantes();
      const valoresDemandados = this.cargarDemandados();

      for (const demandante of valoresDemandantes) {
        const { id, direccion, correo } = demandante.value;
        const item = `${id};${direccion};${correo}`;
        demandantes.push(item);
      }

      for (const demandado of valoresDemandados) {
        const { id, direccion, correo } = demandado.value;
        const item = `${id};${direccion};${correo}`;
        demandados.push(item);
      }
      this.tramiteSfc = {
        ...this.tramiteSfc,
        notificacionesDemandante: demandantes,
        notificacionesDemandado: demandados,
      };
    }
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    this.tramiteSfc.paso = paso;
    this.tramiteSfc.usuario = {
      id: infoInicioSesion.idUsuario,
    };
    await alertas.confirmacion(
      this.alertaText['recordatorio-campos-obligatorios'],
      this.alertaText['almacenar-progeso-solicitud'],
      async () => {
        try {

          if (this.tramiteSfc) {
            this.tramiteSfc.enviar = false;
            const response = await this.callServiceCrearTramite(this.tramiteSfc);
            if (response.success) {
              if (op) {
                op();
              } else {
                loc.back();
              }
            } else {
              await alertas.confirmacion(
                this.alertaText['salir-o-continuar-diligenciando'],
                this.alertaText['datos-no-guardados'],
                () => {
                  if (op) {
                    op();
                  } else {
                    loc.back();
                  }
                },
                () => {
                  // El usuario decide continuar diligenciando
                }
              );
            }
          } else {
            await alertas.confirmacion(
              this.alertaText['salir-o-continuar-diligenciando'],
              this.alertaText['datos-no-guardados'],
              () => {
                if (op) {
                  op();
                } else {
                  loc.back();
                }
              },
              () => {
                // El usuario decide continuar diligenciando
              }
            );
          }
        } catch (error) {
          // Manejo de errores de llamada al servicio
          await alertas.confirmacion(
            this.alertaText['salir-o-continuar-diligenciando'],
            this.alertaText['datos-no-guardados'],
            () => {
              if (op) {
                op();
              } else {
                loc.back();
              }
            },
            () => {
              // El usuario decide continuar diligenciando
            }
          );
        }
      },
      () => {
        if (op) {
          op();
        } else {
          loc.back();
        }
      }
    );
  }

  guardarSinEnviarTramite(data: {
    tramite: TramiteSuperfinancieraDto;
    event?: Event
  }) {
    const tramite = data.tramite;
    tramite.id = this.tramiteSfc?.id;
    tramite.idTipoTramite = Constants.TRAMITES.SUPER_FINANCIERA;
    tramite.enviar = false;

    this.callServiceCrearTramite(tramite);
  }

  async callServiceCrearTramite(
    tramite: TramiteSuperfinancieraDto
  ): Promise<{
    success: boolean;
    message?: string;
  }> {
    try {
      this.limpiarDemandantes(tramite);
      tramite.idioma = this.idiomaActual;
      const response = await firstValueFrom(
        this.service.postCrearTramite(tramite)
      );
      if (response.success) {
        if (this.paso == 1 || this.paso == 2) {
          this.tramiteSfc = {
            id: response.data?.Id,
            idTipoTramite: response.data?.Id_Tipo_Tramite
          };
        } else {
          let tramiteSfc: TramiteSuperfinancieraDto = JSON.parse(
            sessionStorage.getItem('tramiteSfc') ?? '{}');
          this.tramiteSfc = {
            id: response.data?.Id,
            idTipoTramite: response.data?.Id_Tipo_Tramite,
            ...tramiteSfc
          }
        }
        await this.alertaModalService.exito(
          this.alertaText['solicitud-pendiente-finalizar'],
          this.alertaText['sfc-alertas']['tramite-enviado-mensaje'].replace('{{proceso}}', this.proceso)
        );
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false };
    }
  }

  getFormDemandante(form: {
    formTipoPersonaDemandante: FormGroup;
    formDemandante: FormGroup;
  }) {
    this.formTipoDemandante = form.formTipoPersonaDemandante;
    this.formDemandante = form.formDemandante;
  }

  getFormApoderado(form: { formApoderado: FormGroup }) {
    this.formApoderado = form.formApoderado;
  }

  agregarApoderado(): void {
    if (!this.formApoderado) {
      return;
    }

    this.formApoderado.updateValueAndValidity();
    const formValues = this.formApoderado.getRawValue();

    const apoderado: PersonaDto = {
      idTipoPersona: 1,
      idTipoIdentificacion: formValues.typeOfDocument,
      identificacion: formValues.numberOfDocument,
      primerNombre: formValues.primerNombre,
      segundoNombre: formValues.segundoNombre,
      primerApellido: formValues.primerApellido,
      segundoApellido: formValues.segundoApellido,
      correoElectronico: formValues.email,
      direccionPersona: [
        { direccionNotificacion: formValues.address },
      ],
      municipio: {
        id: Number(formValues.municipality),
        idDepartamento: Number(formValues.departament),
        idPais: +formValues.country,
      },
      tarjetaProfesional: formValues.professionalCard,
      departamentoExtranjero: formValues.otroDepartamento,
      ciudadExtranjero: formValues.otroMunicipio,
    };

    let apoderadoStorage: PersonaDto[] = JSON.parse(sessionStorage.getItem('apoderados') ?? '[]');

    const existe = apoderadoStorage.some(
      item =>
        item.idTipoIdentificacion === apoderado.idTipoIdentificacion &&
        item.identificacion === apoderado.identificacion
    );

    const isEmptyDemandado = this.searchInDemandados(+formValues.typeOfDocument, +formValues.numberOfDocument);
    const isEmptyDemandante = this.searchInDemandantes(+formValues.typeOfDocument, +formValues.numberOfDocument);

    if (isEmptyDemandado && isEmptyDemandante) {
      if (!existe) {
        apoderadoStorage.push(apoderado);
      } else {
        const index = apoderadoStorage.findIndex(
          item =>
            item.idTipoIdentificacion === apoderado.idTipoIdentificacion &&
            item.identificacion === apoderado.identificacion
        );
        apoderadoStorage[index] = apoderado;
      }

      sessionStorage.setItem('apoderados', JSON.stringify(apoderadoStorage));

      if (!this.tramiteSfc) {
        this.tramiteSfc = {} as TramiteSuperfinancieraDto;
      }
      this.tramiteSfc.apoderados = apoderadoStorage;
      this.tramiteSfc.tieneApoderado = true;
    }
  }

  getFormDemandado(form: {
    formDemandado: FormGroup;
  }) {
    this.formDemandado = form.formDemandado;
  }

  agregarDemandado() {
    const representante: PersonaDto = {
      primerNombre: this.formDemandado.get('representanteLegal')?.value
    }
    const demandado: PersonaDto = {
      idTipoPersona: 2,
      idTipoIdentificacion: 5,
      identificacion: this.formDemandado.get('identificacion')?.value,
      razonSocial: this.formDemandado.get('razonSocial')?.value,
      primerNombre: this.formDemandado.get('nombreRazonSocial')?.value,
      correoElectronico: this.formDemandado.get('email')?.value,
      direccionPersona: [
        {
          direccionNotificacion: this.formDemandado.get('direccion')?.value,
        },
      ],
      datosRepresentanteLegal: representante
    };

    const isEmptyDemandante: boolean = this.searchInDemandantes(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );
    const isEmptyApoderado: boolean = this.searchInApoderado(
      demandado.idTipoIdentificacion!,
      +demandado.identificacion!
    );
    let demandados: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandados')!
    );

    const existe = demandados
      ? demandados.some(
        item =>
          item.idTipoIdentificacion === demandado.idTipoIdentificacion &&
          item.identificacion === demandado.identificacion
      )
      : false;
    if (isEmptyDemandante && isEmptyApoderado) {
      if (existe == false) {
        if (this.tramiteSfc) {
          this.tramiteSfc.demandado ??= [];
          this.tramiteSfc.demandado.push(demandado);
        }
      } else {
        demandados.forEach(elemento => {
          if (this.tramiteSfc) {
            this.tramiteSfc.demandado ??= [];
            this.tramiteSfc.demandado.push(elemento);
          }
        });
      }
    }
  }

  searchInDemandantes(
    idTipoDocumento: number,
    identificacion: number
  ): boolean {
    let isEmpty = true;
    let demandantes: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandantes')!
    );
    if (demandantes) {
      demandantes.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion == idTipoDocumento &&
          +elemento.identificacion! == identificacion
        ) {
          isEmpty = false;
        }
      });
    } else if (this.tramiteSfc) {
      if (this.tramiteSfc.demandante) {
        this.tramiteSfc.demandante.forEach(elemento => {
          if (
            elemento.idTipoIdentificacion == idTipoDocumento &&
            +elemento.identificacion! == identificacion
          ) {
            isEmpty = false;
          }
        });
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInDemandados(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    let demandados: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('demandados')!
    );

    if (demandados) {
      demandados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion == idTipoDocumento &&
          +elemento.identificacion! == identificacion
        ) {
          isEmpty = false;
        }
      });
    } else if (this.tramiteSfc) {
      if (this.tramiteSfc.demandado) {
        this.tramiteSfc.demandado.forEach(elemento => {
          if (
            elemento.idTipoIdentificacion == idTipoDocumento &&
            +elemento.identificacion! == identificacion
          ) {
            isEmpty = false;
          }
        });
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  searchInApoderado(idTipoDocumento: number, identificacion: number): boolean {
    let isEmpty = true;
    let apoderados: PersonaDto[] = JSON.parse(
      sessionStorage.getItem('apoderados')!
    );

    if (apoderados) {
      apoderados.forEach(elemento => {
        if (
          elemento.idTipoIdentificacion == idTipoDocumento &&
          +elemento.identificacion! == identificacion
        ) {
          isEmpty = false;
        }
      });
    } else if (this.tramiteSfc) {
      const apoderados = this.tramiteSfc.apoderado;
      if (Array.isArray(apoderados)) {
        apoderados.forEach(elemento => {
          if (
            elemento.idTipoIdentificacion == idTipoDocumento &&
            +elemento.identificacion! == identificacion
          ) {
            isEmpty = false;
          }
        });
      }
    } else {
      isEmpty = true;
    }
    return isEmpty;
  }

  getFormDetalle(form: {
    formDetalleRequest?: FormGroup;
    formDetalleRequestTramite?: FormGroup;
  }) {
    this.formDetalleRequest = form.formDetalleRequest!;
    this.formDetalleRequestTramite = form.formDetalleRequestTramite!;
  }

  getFormReclamo(form: {
    formReclamo?: FormGroup;
  }) {
    this.formReclamo = form.formReclamo!;
  }

  getFormNotificaciones(form: {
    demandantes?: FormArray;
    demandados?: FormArray;
  }) {
    this.formNotificacionesDemandantes = form.demandantes!;
    this.formNotificacionesDemandados = form.demandados!;
  }

  cargarDemandantes() {
    let demandantes: [] | any = [];
    const listaDemandantes = this.tramiteSfc?.demandante;

    const identificadoresUnicos = new Set();

    listaDemandantes?.forEach(item => {
      const clave = `${item.idTipoIdentificacion}-${item.identificacion}`;

      if (!identificadoresUnicos.has(clave)) {
        identificadoresUnicos.add(clave);


        demandantes.push(this.creardemandantesForm(item));
      }
    });

    return demandantes;
  }


  cargarDemandados() {
    let demandados: [] | any = [];

    const listaDemandados = this.tramiteSfc?.demandado;

    if (listaDemandados?.length) {
      // Llenamos el array de formularios
      listaDemandados.forEach(item => {
        demandados.push(this.creardemandadosForm(item));
      });
    }

    return demandados;
  }

  creardemandantesForm(item: PersonaDto): FormGroup {

    return this.fb.group({
      id: [item.id],
      direccion: [item.direccionPersona?.[0]?.direccionNotificacion ?? ''],
      correo: [item.correoElectronico]
    });
  }

  creardemandadosForm(item: PersonaDto): FormGroup {

    return this.fb.group({
      id: [item.id],
      direccion: [item.direccionPersona?.[0]?.direccionNotificacion ?? ''],
      correo: [item.correoElectronico]
    });
  }

  siguiente(
    data: {
      tramite: TramiteSuperfinancieraDto;
      formValid: boolean;
      event: Event;
      anexos?: AnexoPrecargaResponseDto[];
    },
    paso: number
  ) {
    if (data.tramite.demandante) {
      sessionStorage.setItem(
        'demandantes',
        JSON.stringify(data.tramite.demandante)
      );
    }
    if (data.tramite.apoderados) {
      sessionStorage.setItem(
        'apoderados',
        JSON.stringify(data.tramite.apoderados)
      );
    }
    if (data.tramite.demandado) {
      sessionStorage.setItem(
        'demandados',
        JSON.stringify(data.tramite.demandado)
      );
    }
    if (data.anexos != undefined && data.anexos?.length > 0) {
      sessionStorage.setItem(
        'anexos',
        JSON.stringify(this.archivosPreCargados)
      );
    }

    const indice = this.estadoPasos.findIndex(
      estado => estado.paso === `Paso ${paso}`
    );

    if (indice !== -1) {
      // Si el paso existe, reemplazar su valor
      this.estadoPasos[indice].valor = data.formValid;
    } else {
      // Si el paso no existe, agregarlo a la lista
      if (paso == 1) {
        this.estadoPasos.push({
          paso: `Paso ${paso}`,
          valor: data.tramite?.demandante?.length! > 0,
        });
      } else {
        this.estadoPasos.push({ paso: `Paso ${paso}`, valor: data.formValid });
      }
    }

    const tramite = data.tramite;

    this.limpiarDemandantes(data.tramite);

    if (this.tramiteSfc && this.tramiteSfc.data?.Id) {
      this.idTramite = this.tramiteSfc.data?.Id;
      tramite.id = this.tramiteSfc?.id;
      tramite.idTipoTramite = this.tramiteSfc?.idTipoTramite;
    }
    this.ultimoPaso = paso === 5;
    this.paso = paso + 1;
    tramite.idioma = this.idiomaActual;
    this.service.postCrearTramite(tramite)
      .subscribe((dataTramite: TramiteSuperfinancieraDto) => {
        if (this.paso == 1 || this.paso == 2) {
          this.tramiteSfc = {
            id: dataTramite.data?.Id,
            idTipoTramite: dataTramite.data?.Id_Tipo_Tramite
          };
        } else {
          let tramiteSfc: TramiteSuperfinancieraDto = JSON.parse(
            sessionStorage.getItem('tramiteSfc') ?? '{}');
          this.tramiteSfc = {
            id: dataTramite.data?.Id,
            idTipoTramite: dataTramite.data?.Id_Tipo_Tramite,
            ...tramiteSfc
          }
        }
      });
    this.continuarLineaAvance(data.event);
  }

  private limpiarDemandantes(tramite: TramiteSuperfinancieraDto): void {
    if (!tramite) return;

    if (Array.isArray(tramite.demandante) && tramite.demandante.length > 0) {
      tramite.demandante = tramite.demandante.filter(
        d =>
          d &&
          d.idTipoPersona &&
          d.idTipoPersona > 0 &&
          d.idTipoIdentificacion &&
          d.identificacion &&
          d.identificacion.toString().trim() !== ''
      );
    }
  }

  enviarTramite(data: {
    tramite: TramiteSuperfinancieraDto;
    event: Event;
  }) {
    const tramite = data.tramite;
    tramite.id = this.tramiteSfc?.id;
    tramite.enviar = true;
    this.enviar(tramite);
  }

  async enviar(
    tramite: TramiteSuperfinancieraDto,
    archivo: ArchivosFormDTO | null | undefined = undefined
  ): Promise<{ success: boolean; message?: string }> {
    tramite['tipoTramiteNombreCorto'] = this.nombreCortoLimpio;

    if (tramite.demandante) {
      tramite.demandante.forEach(demandante => {
        if (demandante.idTipoPersona == Constants.TIPO_PERSONA.NATURAL) {
          demandante.datosRepresentanteLegal = null;
        }
      });
    }
    if (tramite.apoderado?.identificacion == undefined) {
      delete tramite.apoderado;
    }

    try {
      tramite.idioma = this.idiomaActual;
      const response = await firstValueFrom(
        this.service.postCrearTramite(tramite)
      );
      if (response?.data?.Id) {
        if (tramite.enviar) {
          await this.alertaModalService
            .exito(
              this.alertaText['proceso-enviado'],
              this.alertaText['sfc-alertas']['tramite-enviado'].replace('{{entidad}}', this.entidad)
            )
            .then(() => {
              this.router.navigate(['/expediente']);
            });
        } else {
          await this.alertaModalService.exito(
            this.alertaText['solicitud-pendiente-finalizar'],
            this.alertaText['sfc-alertas']['tramite-enviado-mensaje']

          );
        }
        return { success: true };
      } else {
        return { success: false };
      }
    } catch (error) {
      return { success: false };
    }
  }

  //Funciones para el manejo de pasos en la linea de avance (funciónes externa de govco.js)
  continuarLineaAvance(event: Event): void {
    const bodyActive = (event.target as HTMLElement).closest(
      '.body-linea-avance-govco'
    ) as HTMLElement;
    const idParent = bodyActive.getAttribute('data-la-parent');
    const elementParent = document.querySelector(idParent!) as HTMLElement;
    const headers = elementParent.querySelectorAll(
      '.header-linea-avance-govco'
    ) as NodeListOf<HTMLElement>;
    const bodys = elementParent.querySelectorAll('.body-linea-avance-govco');

    const indexActive = this.getActiveItemAdvanceLine(headers);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).nextItemAdvanceLineHorizontal(event);

    headers[indexActive].classList.remove('active-linea-avance-govco');
    headers[indexActive].classList.add('checked-linea-avance-govco');
    headers[indexActive + 1].classList.add('active-linea-avance-govco');
    headers[indexActive + 1].classList.remove('checked-linea-avance-govco');
    bodys[indexActive].classList.remove('active-linea-avance-govco');
    bodys[indexActive + 1].classList.add('active-linea-avance-govco');
  }

  getActiveItemAdvanceLine(headers: NodeListOf<HTMLElement>): number {
    for (let i = 0; i < headers.length; i++) {
      if (headers[i].classList.contains('active-linea-avance-govco')) {
        return i;
      }
    }
    return 0;
  }

}
